import { render, staticRenderFns } from "./table-goal-setting.component.vue?vue&type=template&id=1de5373b&scoped=true"
import script from "./table-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./table-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./table-goal-setting.component.vue?vue&type=style&index=0&id=1de5373b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5373b",
  null
  
)

export default component.exports